<div class="form-control-container">
  @if (label) {
  <label class="input-label"
    >{{ label }}@if (requiredMark) {<span class="required-mark">&nbsp;*</span
    >}</label
  >
  }
  <div class="textarea-container">
    <textarea
      class="textarea"
      ngxAutosize
      [enable]="autoSize"
      [ngModel]="value"
      [maxlength]="maxLength"
      [class.ng-invalid]="!ngControl?.valid"
      [class.ng-valid]="ngControl?.valid"
      [class.ng-touched]="ngControl?.touched"
      [class.ng-untouched]="!ngControl?.touched"
      [class.ng-pristine]="ngControl?.pristine"
      [class.ng-dirty]="!ngControl?.pristine"
      [placeholder]="placeholder"
      [attr.disabled]="disabled || null"
      [disabled]="!!disabled"
      (focus)="onFocus()"
      (blur)="onBlur()"
      (ngModelChange)="setValue($event)"
    ></textarea>
  </div>
  @if (maxLength) {
  <div
    class="counter"
    i18n="
      Label | Label for max amount of characters in the
      textarea@@textareaMaxCharactersLabel"
  >
    {{ characterCount }} / {{ maxLength }} caractères
  </div>
  }
</div>
